import { DialogComponent, DialogCloseEvent } from '@theme/dialog';

/**
 * Mobile product gallery popup video with muted preview and unmuted modal playback.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog
 * @property {HTMLButtonElement} trigger
 * @property {HTMLVideoElement} previewVideo
 * @property {HTMLVideoElement} playerVideo
 *
 * @extends {DialogComponent<Refs>}
 */
class ProductPopupVideo extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(DialogCloseEvent.eventName, this.#handleClose);
    this.refs.dialog?.addEventListener('click', this.#handleDialogSurfaceClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener(DialogCloseEvent.eventName, this.#handleClose);
    this.refs.dialog?.removeEventListener('click', this.#handleDialogSurfaceClick);
  }

  openPopup = () => {
    const { previewVideo, playerVideo } = this.refs;

    this.showDialog();
    previewVideo?.pause();

    if (!playerVideo) return;

    playerVideo.muted = false;
    playerVideo.currentTime = 0;
    playerVideo.play().catch(() => {});
  };

  togglePlayPause = (event) => {
    event?.stopPropagation?.();

    const { playerVideo } = this.refs;
    if (!playerVideo) return;

    if (playerVideo.paused) {
      playerVideo.play().catch(() => {});
    } else {
      playerVideo.pause();
    }
  };

  /** @param {MouseEvent} event */
  #handleDialogSurfaceClick = (event) => {
    const { dialog, playerVideo } = this.refs;

    if (event.target === playerVideo || playerVideo?.contains(event.target)) return;
    if (event.target instanceof Element && event.target.closest('.product-popup-video__close')) return;

    if (event.target === dialog || event.target instanceof Element && event.target.closest('.product-popup-video__player-wrap')) {
      this.closeDialog();
    }
  };

  #handleClose = () => {
    const { previewVideo, playerVideo } = this.refs;

    if (playerVideo) {
      playerVideo.pause();
      playerVideo.muted = true;
      playerVideo.currentTime = 0;
    }

    if (previewVideo) {
      previewVideo.muted = true;
      previewVideo.play().catch(() => {});
    }
  };
}

if (!customElements.get('product-popup-video')) {
  customElements.define('product-popup-video', ProductPopupVideo);
}
